import { observer } from "mobx-react";
import MainLayout from "newApp/components/layouts/MainLayout";
import FlexColumn from "newApp/kit/components/FlexColumn";
import H1 from "newApp/kit/components/H1";
import React from "react";
import SiteNavigator from "newApp/components/SiteNavigator";
import DocsNavigator from "newApp/components/DocsNavigator";

const DocsPage: React.FC = () => {
  return (
    <MainLayout>
      <H1>Вопросы личного кабинета</H1>
      <FlexColumn>
        <SiteNavigator />
        <DocsNavigator />
      </FlexColumn>
    </MainLayout>
  );
};

export default observer(DocsPage);
